<template>
  <div class="formimmutablefield">
    <span class="formimmutablefield-title">{{ title }}</span>
    <div class="formimmutablefield-text">{{ text }}</div>
  </div>
</template>

<script>
export default {
  name: 'FormImmutableField',
  props: {
    title: {
      type: String,
      default: ''
    },
    text: {
      type: [String, Number],
      default: ''
    }
  }
};
</script>

<style lang="scss" scoped>
.formimmutablefield {
  width: 100%;
  display: flex;
  align-items: center;
  &-title {
    flex: 0 0 100px;
    margin-bottom: 0;
  }
}

.widerlabel {
  .formimmutablefield-title {
    flex: 0 0 120px;
  }
}

.hugelabel {
  .formimmutablefield-title {
    flex: 0 0 150px;
  }
}
</style>
